@if (commitment !== undefined && flyoutDataSubType !== flyoutDataType.FormResponses) {
  <div class="flyout-star-scoring">
    @for (item of [].constructor(7); track $index; let i = $index) {
      @if (i < commitment) {
        <mat-icon>star</mat-icon>
      }
      @if (i >= commitment) {
        <mat-icon>star_border</mat-icon>
      }
    }
  </div>
}
